import { useMemo } from 'react'

import { RedemptionStatusEnum } from 'common/enums/RedemptionStatusEnum'
import { ITicket } from 'store/afterSales/types'

interface Props {
  tickets: ITicket[]
}

export const useSortCompletedSentRedemption = ({ tickets }: Props) => {
  const sortedTickets = useMemo(() => {
    if (!tickets || tickets.length === 0) {
      return []
    }

    const sentToRedemption: ITicket[] = []
    const others: ITicket[] = []

    tickets.forEach((ticket) => {
      if (ticket.redemptionStatus === RedemptionStatusEnum.SENT_TO_REDEMPTION) {
        sentToRedemption.push(ticket)
      } else {
        others.push(ticket)
      }
    })

    return [...sentToRedemption, ...others]
  }, [tickets])

  return { sortedTickets }
}
